angular
  .module('app', ['ui.router', 'ui.scroll', 'ui.scroll.jqlite', 'angularMoment']).constant('angularMomentConfig', {
    timezone: 'UTC' // e.g. 'Europe/London'
});;

angular
    .module('app')
    .component('fountainTechs', {
        templateUrl: 'app/techs/techs.html',
        controller: TechsController,
        bindings: {
            topic: '<',
            keywords: '<'
        }
    });

/** @ngInject */
function TechsController($http, $timeout) {
    var vm = this;

    var doc_ids = [];
    vm.news = {response: {docs: []}};
    function perdiocReload() {
        $http
            .get('https://www.newscombinator.com/api/search',{params: {q:'(_val_:"recip(ms(NOW/HOUR,created_at),3.16e-9,2700,1)"^15 ) +('+(vm.keywords)+') +language:en -title_link:free -title_link:gambling -title_link:faucet  -title_link:New\\ on\\ \\\#steemit\\:', 'rows': 10}})
            .then(function (response) {
                for(var i = 0; i < response.data.response.docs.length; i++) {
                    if(doc_ids.indexOf(response.data.response.docs[i].id) === -1) {
                        doc_ids.push(response.data.response.docs[i].id);

                        vm.news.response.docs.unshift(response.data.response.docs[i]);
                        var items = [];
                        items.push(response.data.response.docs[i]);
                        if (vm.adapterContainer.adapter.isBOF()) {
                            vm.adapterContainer.adapter.prepend(items);
                        }
                        if (Notification.permission === "granted") {
                            var notification = new Notification(items.length+" items in "+vm.topic, {body: items[0].title_website});
                            setTimeout(function() {
                                notification.close();
                            },4500);
                        }
                    }
                }

                $timeout(perdiocReload, 60000 + Math.round(Math.random()*10000));
            });
    }
    $http
        .get('https://www.newscombinator.com/api/search',{params: {q:'(_val_:"recip(ms(NOW/HOUR,created_at),3.16e-9,2700,1)"^15 ) +('+vm.keywords+') +language:en -title_link:free -title_link:gambling -title_link:faucet -title_link:New\\ on\\ \\\#steemit\\:', 'rows': 50}})
        .then(function (response) {
            vm.news = response.data;

            for(var i = 0; i < response.data.response.docs.length; i++) {
                doc_ids.push(response.data.response.docs[i].id);
            }
            vm.adapterContainer.adapter.reload();

            $timeout(perdiocReload, 60000 + Math.round(Math.random()*10000));
        });


    vm.newselements = {};
    vm.newselements.get = function (index, count, success) {
        var i, items = [], item;

        for (i = index; i < index + count; i++) {

            if(i < 0 || i >= vm.news.response.docs.length) {
                continue;
            }
            item = vm.news.response.docs[i];
            items.push(item);
        }


        success(items);
    };



    vm.adapterContainer = { adapter: {
        remain: true
    }};
}

angular
  .module('app')
  .component('fountainTitle', {
    templateUrl: 'app/title.html'
  });

angular
    .module('app')
    .component('app', {
        templateUrl: 'app/main.html',
        controller: function () {
            if (Notification.permission !== 'denied' && Notification.permission !== 'granted') {
                Notification.requestPermission(function (permission) {
                    // If the user accepts, let's create a notification
                    if (permission === "granted") {
                        var notification = new Notification("You will see a notification if new news arrives!");
                    }
                });
            }

        }
    });

angular
  .module('app')
  .component('fountainHeader', {
    templateUrl: 'app/header.html'
  });

angular
  .module('app')
  .component('fountainFooter', {
    templateUrl: 'app/footer.html'
  });

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/footer.html","<footer class=\"footer\">\n  Build with ♥ by the&nbsp;\n  <a href=\"http://www.newscombinator.com\">\n    Newscombinator\n  </a>\n</footer>\n");
$templateCache.put("app/header.html","<header class=\"header\">\n  <p class=\"header-title\">\n    <a href=\"/#/\" target=\"_blank\">\n      Crypto FOMO Buster\n    </a>\n  </p>\n  <p class=\"header-date\">\n    Control your FOMO, trade fundamentals with research!\n  </p>\n</header>\n");
$templateCache.put("app/main.html","<fountain-header></fountain-header>\n<div class=\"container-fluid\">\n    <div class=\"row\">\n        <div class=\"col-lg-12 text-center\">\n            <br>This tool aggregates news about different crypto-currencies.<br>\n            It will search through title and content if a currency is mentioned.<br>\n            <b>You don\'t have to refresh.</b> It\'ll auto-prepend news.<br>\n            You get desktop notifications if there is something new. Happy trading!\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-lg-4\">\n            <fountain-techs topic=\"\'Augur\'\" keywords=\"\'Augur\'\"></fountain-techs>\n        </div>\n        <div class=\"col-lg-4\">\n            <fountain-techs topic=\"\'Iconomi\'\" keywords=\"\'Iconomi\'\"></fountain-techs>\n        </div>\n        <div class=\"col-lg-4\">\n            <fountain-techs topic=\"\'ETHETC (Ethereum)\'\" keywords=\"\'Ethereum ETH ETC\'\"></fountain-techs>\n        </div>\n        <div class=\"col-lg-4\">\n            <fountain-techs topic=\"\'XMR Monero\'\" keywords=\"\'Monero XMR\'\"></fountain-techs>\n        </div>\n        <div class=\"col-lg-4\">\n            <fountain-techs topic=\"\'SDC Shadowcoin\'\" keywords=\"\'Shadowcoin SDC\'\"></fountain-techs>\n        </div>\n        <div class=\"col-lg-4\">\n            <fountain-techs topic=\"\'XRP Ripple\'\" keywords=\"\'Ripple XRP\'\"></fountain-techs>\n        </div>\n        <div class=\"col-lg-4\">\n            <fountain-techs topic=\"\'MAID Maidsafe\'\" keywords=\"\'Maidsafe Madesafecoin\'\"></fountain-techs>\n        </div>\n        <div class=\"col-lg-4\">\n            <fountain-techs topic=\"\'DASH\'\" keywords=\"\'DASH\'\"></fountain-techs>\n        </div>\n        <div class=\"col-lg-4\">\n            <fountain-techs topic=\"\'FCT Factom\'\" keywords=\"\'Factom FCT\'\"></fountain-techs>\n        </div>\n        <div class=\"col-lg-4\">\n            <fountain-techs topic=\"\'STR Stellar\'\" keywords=\"\'Stellar STR\'\"></fountain-techs>\n        </div>\n        <div class=\"col-lg-4\">\n            <fountain-techs topic=\"\'STEEM\'\" keywords=\"\'STEEM Steemit\'\"></fountain-techs>\n        </div>\n        <div class=\"col-lg-4\">\n            <fountain-techs topic=\"\'LTC Litecoin\'\" keywords=\"\'Litecoin LTC\'\"></fountain-techs>\n        </div>\n        <div class=\"col-lg-4\">\n            <fountain-techs topic=\"\'AMP Synero\'\" keywords=\"\'Synero AMP\'\"></fountain-techs>\n        </div>\n        <div class=\"col-lg-4\">\n            <fountain-techs topic=\"\'DOGE\'\" keywords=\"\'Dogecoin Doge\'\"></fountain-techs>\n        </div>\n        <div class=\"col-lg-4\">\n            <fountain-techs topic=\"\'NAUT Nautiluscoin\'\" keywords=\"\'Nautiluscoin NAUT\'\"></fountain-techs>\n        </div>\n    </div>\n</div>\n<fountain-footer></fountain-footer>\n");
$templateCache.put("app/title.html","<div class=\"title\">\n  <h1 class=\"title-h1\">Hold your emotions!</h1>\n</div>\n");
$templateCache.put("app/techs/techs.html","<h2>\n    {{$ctrl.topic}}\n</h2>\n<div ui-scroll-viewport style=\"height: 350px\">\n    <div ui-scroll=\"news in $ctrl.newselements\" adapter=\"$ctrl.adapterContainer.adapter\">\n        <a class=\"small\" target=\"_blank\" href=\"{{news.url}}\">{{news.title_link}}</a> <span class=\"small\" am-time-ago=\"news.created_at\"></span>\n    </div>\n</div>\n");}]);
angular
  .module('app')
  .config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true).hashPrefix('!');
  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('app', {
      url: '/',
      component: 'app'
    });
}
